import { Injectable, Inject, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { App } from '@df/core/app';
import { Resource } from '@df/catalog/resource';
import { Stock } from '@df/catalog/stock/stock';
import { CookiesService } from '@df/core/service/cookies';

declare module '@df/catalog/resource' {
    interface IResources {
        stock: Resource<Stock, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class StockResource extends Resource<Stock, number> {
    static override instance = Stock;
    readonly invalidatesUniversal = false;
    readonly invalidatesPrerender = false;
    private cookieService = inject(CookiesService);

    private fakeStockQty?: number;
    private fakeStockBackorderQty?: number;

    constructor() {
        super();
        const fakeStockQty = this.cookieService.get('_fakeStockQty');
        if (fakeStockQty) {
            this.fakeStockQty = Number(fakeStockQty);
        }
        const fakeStockBackorderQty = this.cookieService.get('_fakeStockBackorderQty');
        if (fakeStockBackorderQty) {
            this.fakeStockBackorderQty = Number(fakeStockBackorderQty);
        }

        if (this.fakeStockQty || this.fakeStockBackorderQty) {
            this.addPlugin(model => {
                model.fakeStockQty = this.fakeStockQty;
                model.fakeStockBackorderQty = this.fakeStockBackorderQty;
            });
        }
    }
}
